<script>
export default {
  data() {
    return {
      sourceList: [
        { label: 'order.allSource', key: '' },
        { label: 'order.mergeOrders', key: 'MERGE' },
        { label: 'common.smallRoutine', key: 'USER' },
        { label: 'order.manualOrder', key: 'ADMIN' },
      ],
      stateFilter: {
        CREATED: 'CREATED',
        STORE_SENT: 'STORE_SENT'
      },
      storeState: { // 出库单状态
        STORE_COLLECTED: 'STORE_COLLECTED', // 已揽收
        STORE_ZITI_COLLECTED: 'STORE_ZITI_COLLECTED', // 自提待发货
        STORE_SENT: 'STORE_SENT', // 已发货
        STORE_RECEIVE: 'STORE_RECEIVE', // 已签收
        OFFICER_CLOSED: 'OFFICER_CLOSED', // 已关闭
        PUSH_REFUSE: 'PUSH_REFUSE', // 已驳回
      },
      pushStoreState: { // 出库单推送状态
        CANCEL: 2, // 取消推送
        REFUSE: 5, // 已驳回
      }
    }
  },
  computed: {
    storeStates() { // 出库单状态
      let list = [];
      for (let st in this.storeState) {
        console.log(this.storeState[st]);
        const t = this.storeState[st];
        list.push({ key: t, label: this.$t('order_state.' + t) });
      }
      return list;
    },
    storeExceptions() {
      const s = this.$store.state.storeExceptions;
      return s.map(state => ({key: state === 'NO_EXCEPTION' ? null : state, label: this.$t('order_state.' + state)}));
    },
  },
  methods: {
    getSourceLabel(r) {
      const l = this.$f.matchData(this.sourceList, r.own_role, 'key');
      let label = this.$t(l);
      if (r.merge_order_id) {
        label += `(${this.$t('order.merged')})`
      }
      return label
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/order/orderFilter.vue